export default {
  methods: {
    getLastUsedPrinterTypeId(fileId = null) {
      let printerTypeId;
      if (fileId) {
        printerTypeId = this.$store.getters.getPrinterTypeIdByFileId(fileId)
      }
      if (!printerTypeId) {
        printerTypeId = this.$store.getters.lastUsedPrinterTypeId;
      }

      return printerTypeId;
    },

    getPrimaryPrinterTypeId(fileId = null) {
      let printerTypeId = this.getLastUsedPrinterTypeId(fileId);
      if (!printerTypeId) {
        const activePrinters = this.$store.getters.getActivePrinters.filter(printer => printer.virtual === 'f');
        if (activePrinters.length > 0) {
          printerTypeId = activePrinters[0].printer_type_id;
        }
      }
      if (!printerTypeId) {
        printerTypeId = this.$store.getters.defaultPrinterTypeId;
      }

      return printerTypeId;
    },

    getUserActivePrinterTypes() {
      let uniquePrinterTypes = {};
      this.$store.getters.getActivePrinters.map(printer => {
        uniquePrinterTypes[printer.printer_type_id] = true;
      });

      return Object.keys(uniquePrinterTypes);
    }
  },
}
